<template>
<!-- 研究总结旭日图 -->
  <div class="sunburst">
    <div ref="sunburstContainer" class="container"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    initChart() {
      const container = this.$refs.sunburstContainer;
      const myChart = echarts.init(container);
      const option = {
        color: [
          '#19d4ae', '#5ab1ef', '#fa6e86',
          '#ffb980', '#0067a6', '#c4b4e4',
          '#d87a80', '#9cbbff', '#d9d0c7',
          '#87a997', '#d49ea2', '#5b4947',
          '#7ba3a8'
        ],
        series: {
          type: 'sunburst',
          silent: false,
          data: this.chartData,
          radius: [0, '90%'],
          label: {
              rotate: 'radial'
          }
        }
      };
      myChart.setOption(option)
    }
  },
  mounted() {
    this.initChart();
  },
  
}
</script>
<style lang="less" scoped>
.sunburst {
  .container {
    width: 100%;
    height: 400px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Sunburst.vue